<div class="app-wrapper" @fade [@routerTransition]="getAnimationSettings()" *ngIf="!loading">
	<router-outlet></router-outlet>
</div>

<div class="loading-container" *ngIf="loading">
	<mat-spinner *ngIf="customStylesLoaded" [diameter]="40"></mat-spinner>
</div>
